import { entityDecoder } from '../../bastetjs/utils/entityDecoder';
import distanceConverter from '../distanceConverter';
import { Configure, ErosApi, FetchApi } from '../../anuket-http';

export function getRaceDistancesByEventId({ eventId, athlinksId }) {
  const id = eventId || athlinksId;
  const streamId = 'GetRaceDistances' + (eventId ? '-' : 'WithAthlinksId-') + id;

  const body = {
    '_source': [
      'id',
      'event_id',
      'athlinks_id',
      'name',
      'tag',
      'pref_distance_unit',
      'course_distance'
    ],
    query: {
      term: (eventId ? {'event_id': id} : {'athlinks_id': id})
    },
    'sort': [
       { 'course_distance': {
           'order': 'asc'
         }
       }
    ]
  };

  return ErosApi
    .query(streamId, 'race_bkt_*/ctlive/_search', body)
    .map((msg) => {

      if ('isLoading' in msg && msg.isLoading) {
        return msg;
      }

      return entityDecoder.decode({
        races: msg.hits.map((hit) => {
          const distance = distanceConverter.getDistanceFromCTLiveRace(
            hit.pref_distance_unit,
            hit.course_distance);

          return {
            id: hit.id,
            eventId: hit.event_id,
            athlinksId: hit.athlinks_id,
            distance: distance.displayValue
          };
        })
      });
    });
}

export function getRaceTypesByEventId({ eventId, athlinksId }) {
  const id = eventId || athlinksId;
  const streamId = 'GetRaceTypes' + (eventId ? '-' : 'WithAthlinksId-') + id;

  const body = {
    '_source': [
      'id',
      'event_id',
      'athlinks_id',
      'name',
      'type',
      'sub_type'
    ],
    query: {
      term: (eventId ? {'event_id': id} : {'athlinks_id': id})
    },
  };

  return ErosApi
    .query(streamId, 'race_bkt_*/ctlive/_search', body)
    .map((msg) => {

      if ('isLoading' in msg && msg.isLoading) {
        return msg;
      }

      return entityDecoder.decode({
        races: msg.hits.map((hit) => {
          return {
            id: hit.id,
            eventId: hit.event_id,
            athlinksId: hit.athlinks_id,
            type: hit.type,
            subType: hit.sub_type,
          };
        })
      });
    })
}

export function getRaceTimesByCTLiveId({eventId}) {
  const url = Configure.getValue('bragiUrl')
            + `/ctl-api/event/${eventId}/race`;

  return FetchApi.doFetch(url).map((msg) => {
    if (msg.event_race) {
      return {
        races: msg.event_race.map((race) => {
          return {
            eventId: parseInt(race.event_id),
            id: parseInt(race.race_id),
            name: race.race_name,
            plannedEndTime: parseInt(race.race_planned_end_time),
            plannedStartTime: parseInt(race.race_planned_start_time),
            subType: race.race_subtype,
            type: race.race_type
          }
        }).sort((a, b) => {
          return a.plannedStartTime < b.plannedStartTime ? -1
            : a.plannedStartTime > b.plannedStartTime ? 1
            : 0;
        })
      }
    }
    else {
      return {
        races: []
      }
    }
  });
}

export function getRaceTimesByEventId({ eventId, athlinksId }) {
  const id = eventId || athlinksId;
  const streamId = 'GetRaceTimes' + (eventId ? '-' : 'WithAthlinksId-') + id;

  const body = {
    '_source': [
      'id',
      'event_id',
      'athlinks_id',
      'name',
      'type',
      'sub_type',
      'planned_start_time',
      'planned_end_time'
    ],
    size: 50,
    query: {
      term: (eventId ? { event_id: eventId } : { 'athlinks_id': athlinksId })
    },
    'sort': [{ 'planned_start_time': {'order': 'asc'}}]
  };

  return ErosApi
    .query(streamId, 'race_bkt_*/ctlive/_search', body)
    .map((msg) => {
      if ('isLoading' in msg && msg.isLoading) {
        return msg;
      }

      return entityDecoder.decode({
        races: msg.hits.map((hit) => {
          return {
            id: hit.id,
            eventId: hit.event_id,
            athlinksId: hit.athlinks_id,
            name: hit.name,
            type: hit.type,
            subType: hit.sub_type,
            plannedStartTime: hit.planned_start_time,
            plannedEndTime: hit.planned_end_time
          };
        })
      });
    })
}

function _getAthlinksRaceFields() {
  return [
    'courseId',
    'meters',
    'eventId',
    'masterId',
    'eventCourseId',
    'startEpoch',
    'eventName',
    'raceName'
  ];
}

function _athlinksRaceQuery(query, size) {
  return {
    _source: _getAthlinksRaceFields(),
    size: size || 10,
    query
  };
}

function _mapHitFields(hit) {
  return {
    courseId: hit.courseId,
    meters: hit.meters,
    eventId: hit.eventId,
    masterId: hit.masterId,
    eventCourseId: hit.eventCourseId,
    startEpoch: hit.startEpoch,
    eventName: hit.eventName,
    raceName: hit.raceName
  }
}

export function getAthlinksCourses({ athlinksId }) {
  const url = Configure.getValue('bragiUrl')
            + `/athlinks/Events/Api/${athlinksId}/Courses`;

  return FetchApi.doFetch(url).map((msg) => {
    if (msg.result) {
      return {
        races: msg.result.courses.map((course) => {
          return {raceName: course.name}
        }).sort((a, b) => {
          return a.raceName < b.raceName ? -1
            : a.raceName > b.raceName ? 1
            : 0;
        })
      }
    }
    else {
      return {races: []}
    }
  });
}

export function getAthlinksRaces({ athlinksId }) {
  const streamId = `GetAthlinksRaces-${athlinksId}`;

  const query = _athlinksRaceQuery({term: {eventId: athlinksId}}, 50);

  return ErosApi
    .query(streamId, 'race_bkt_*/athlinks/_search', query)
    .map((msg) => {
      if ('isLoading' in msg && msg.isLoading) {
        return msg;
      }

      return entityDecoder.decode({
        races: msg.hits
          .map((hit) => _mapHitFields(hit))
          .sort((a, b) => a.raceName > b.raceName)
      });
    })
}

export function extractCourses(msg) {
  if (msg.success && msg.result && msg.result.eventRaces) {
    const now = Date.now() / 1000;
    const eventCourses = msg.result.eventRaces.map((race) => {
      return race.eventCourses.map((course) => {
        return {
          courseId: course.courseID,
          eventCourseId: course.eventCourseID,
          eventId: race.raceID,
          eventName: race.raceName,
          masterId: race.masterEventID,
          meters: course.distUnit,
          raceName: course.courseName,
          startEpoch: (new Date(race.raceDate).getTime() / 1000)
        }
      })
    });
    return {
      races: [].concat.apply([], eventCourses)
    }
  }
  else { return {races: []} }
}

export function getAthlinksRacesByMasterId({ masterId }) {
  const url = Configure.getValue('ATHLINKS_API_HOST')
            + `/MasterEvents/Api/${masterId}`;

  return FetchApi.doFetch(url).map((msg) => extractCourses(msg));
}

export function getRaceByEventCourseId({ eventCourseId }) {
  const streamId = `GetAthlinksRaceByEventCourseId-${eventCourseId}`;

  const query = Object.assign({},
    _athlinksRaceQuery({match: {eventCourseId}})
  );

  return ErosApi
    .query(streamId, 'race_bkt_*/athlinks/_search', query)
    .map((msg) => {
      return 'isLoading' in msg && msg.isLoading
        ? [] : msg.hits.map((hit) => entityDecoder.decode(_mapHitFields(hit)));
    });
}


function _assembleDivisionRecords(msg, hits) {
  return 'isLoading' in msg && msg.isLoading ? [] : hits.map((hit) => entityDecoder.decode(hit));
}

export function getDivisionsByEventId({eventId}) {
  const url = Configure.getValue('ATHLINKS_API_HOST')
            + `/events/race/api/${eventId}/divisions`;

  return FetchApi.doFetch(url).map((msg) => {
    return msg.Success && Array.isArray(msg.Result)
      ? _assembleDivisionRecords(msg, msg.Result).sort((a, b) => a < b ? -1 : 1)
      : [];
  });
}

// For testing
export const RacesNoble = {
  extractCourses,
  getDivisionsByEventId,
  getRaceDistancesByEventId,
  getRaceTypesByEventId,
  getRaceTimesByEventId,
  getAthlinksRaces,
  getAthlinksRacesByMasterId,
  getRaceByEventCourseId
}



/** WEBPACK FOOTER **
 ** ./lib/anuket/nobles/RacesNoble.js
 **/